/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul> */
export enum MeterTypeInternal {
  Unknown = "Unknown",
  Internal = "Internal",
  Standalone = "Standalone",
  BudgetPlug = "BudgetPlug",
}

/** <p>Members:</p><ul><li>0: Unknown</li><li>1: Main</li><li>2: Pv</li><li>3: EnergyStorage</li><li>4: Consumption</li></ul> */
export enum MeterPurposeInternal {
  Unknown = "Unknown",
  Main = "Main",
  Pv = "Pv",
  EnergyStorage = "EnergyStorage",
  Consumption = "Consumption",
}

/** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
export enum MeasurementDataRangeInternal {
  Unknown = "Unknown",
  None = "None",
  InHours = "InHours",
  InDays = "InDays",
  InMonths = "InMonths",
  InYears = "InYears",
}

/** <p>Members:</p><ul><li>0: Unknown</li><li>1: VoltageAvr</li><li>2: VoltageMin</li><li>3: VoltageMax</li><li>4: ForwardActiveEnergy</li><li>5: ReverseActiveEnergy</li><li>6: ForwardReactiveEnergy</li><li>7: ReverseReactiveEnergy</li><li>8: VectorBalancedActiveEnergyIncoming</li><li>9: PredictionForwardActiveEnergy</li><li>10: PredictionVectorBalancedActiveEnergy</li><li>11: DynamicEnergyMarketPrice</li><li>12: VectorBalancedActiveEnergyOutgoing</li><li>700: Price</li><li>701: Cost</li><li>702: VectorBalancedCost</li></ul> */
export enum AggregateVectorParameterTypeInternal {
  Unknown = "Unknown",
  VoltageAvr = "VoltageAvr",
  VoltageMin = "VoltageMin",
  VoltageMax = "VoltageMax",
  ForwardActiveEnergy = "ForwardActiveEnergy",
  ReverseActiveEnergy = "ReverseActiveEnergy",
  ForwardReactiveEnergy = "ForwardReactiveEnergy",
  ReverseReactiveEnergy = "ReverseReactiveEnergy",
  VectorBalancedActiveEnergyIncoming = "VectorBalancedActiveEnergyIncoming",
  PredictionForwardActiveEnergy = "PredictionForwardActiveEnergy",
  PredictionVectorBalancedActiveEnergy = "PredictionVectorBalancedActiveEnergy",
  DynamicEnergyMarketPrice = "DynamicEnergyMarketPrice",
  VectorBalancedActiveEnergyOutgoing = "VectorBalancedActiveEnergyOutgoing",
  Price = "Price",
  Cost = "Cost",
  VectorBalancedCost = "VectorBalancedCost",
}

export interface AddInstallationsToClusterRequest {
  /** @format uuid */
  clusterId: string;
  installationIds: string[];
}

export interface AggregatedSingleVectorMeasurementsClusterIntegrationResponse {
  /** @format uuid */
  meterId: string;
  /** @format uuid */
  installationId: string;
  isSuccessfulFromStorage: boolean;
  isSuccessfulFromDevice: boolean;
  /** @format date-time */
  oldestAtUtc?: string | null;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  total: Record<string, Record<string, number>>;
  items: MultiParameterAggregatedItem[];
}

export interface AggregatedVectorMeasurementsClusterIntegrationResponse {
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  aggregationSummary: AggregationSummary;
}

export interface AggregationSummary {
  purposes: {
    Unknown?: PurposeSummary;
    Main?: PurposeSummary;
    Pv?: PurposeSummary;
    EnergyStorage?: PurposeSummary;
    Consumption?: PurposeSummary;
  };
}

export interface Cluster {
  /** @format uuid */
  id: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  installations: Installation[];
}

export interface DeleteInstallationsFromClusterRequest {
  /** @format uuid */
  clusterId: string;
  installationIds: string[];
}

export interface ErrorResponse {
  message: string;
}

export interface GetPersistedVectorMeasurementResponse {
  /** @format uuid */
  meterId: string;
  /** @format uuid */
  installationId: string;
  isSuccessfulFromStorage: boolean;
  isSuccessfulFromDevice: boolean;
  /** @format date-time */
  oldestAtUtc?: string | null;
  /** @format date-time */
  from: string;
  /** @format date-time */
  to: string;
  items: MultiParameterAggregatedItem[];
}

export interface HourPrice {
  /** @format int32 */
  hour: number;
  /** @format double */
  price: number;
}

export interface Installation {
  /** @format uuid */
  installationId: string;
  /** @format uuid */
  clusterId: string;
  name: string;
  /** @format date-time */
  createdAt: string;
  /** @format date-time */
  updatedAt: string;
  /** @format double */
  latitude?: number | null;
  /** @format double */
  longitude?: number | null;
}

export interface MeterInfoResponse {
  /** @format uuid */
  meterId: string;
  macAddress: string;
  /** @format uuid */
  installationId: string;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Main</li><li>2: Pv</li><li>3: EnergyStorage</li><li>4: Consumption</li></ul> */
  purpose: MeterPurposeInternal;
  /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul> */
  type: MeterTypeInternal;
  supportedAggregateParameters: AggregateVectorParameterTypeInternal[];
}

export interface MultiParameterAggregatedItem {
  /** @format date-time */
  dateAtUtc: string;
  measurements: any;
}

export interface PricesWithDate {
  /** @format date */
  date: string;
  prices: HourPrice[];
}

export interface PurposeSummary {
  total: Record<string, Record<string, number>>;
  items: MultiParameterAggregatedItem[];
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<AxiosResponse<T>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance.request({
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type ? { "Content-Type": type } : {}),
      },
      params: query,
      responseType: responseFormat,
      data: body,
      url: path,
    });
  };
}

/**
 * @title Lavva API
 * @version v1
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterInstallationsCreate
     * @request POST:/api/Cluster/installations
     * @secure
     * @response `200` `void` OK
     * @response `400` `ErrorResponse` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `ErrorResponse` Not Found
     */
    clusterInstallationsCreate: (
      data: AddInstallationsToClusterRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/Cluster/installations`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterInstallationsDelete
     * @request DELETE:/api/Cluster/installations
     * @secure
     * @response `200` `void` OK
     * @response `400` `ErrorResponse` Bad Request
     * @response `401` `void` Unauthorized
     * @response `404` `ErrorResponse` Not Found
     */
    clusterInstallationsDelete: (
      data: DeleteInstallationsFromClusterRequest,
      params: RequestParams = {},
    ) =>
      this.request<void, ErrorResponse | void>({
        path: `/api/Cluster/installations`,
        method: "DELETE",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterInstallationDetail
     * @request GET:/api/Cluster/installation/{id}
     * @secure
     * @response `200` `(MeterInfoResponse)[]` OK
     * @response `401` `void` Unauthorized
     */
    clusterInstallationDetail: (id: string, params: RequestParams = {}) =>
      this.request<MeterInfoResponse[], void>({
        path: `/api/Cluster/installation/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterDynamicMarketPricesList
     * @request GET:/api/Cluster/dynamicMarketPrices
     * @secure
     * @response `200` `(PricesWithDate)[]` OK
     * @response `401` `void` Unauthorized
     */
    clusterDynamicMarketPricesList: (params: RequestParams = {}) =>
      this.request<PricesWithDate[], void>({
        path: `/api/Cluster/dynamicMarketPrices`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterList
     * @request GET:/api/Cluster
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    clusterList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Cluster`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterCreate
     * @request POST:/api/Cluster
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    clusterCreate: (data: Cluster, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Cluster`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterDetail
     * @request GET:/api/Cluster/{id}
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    clusterDetail: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Cluster/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterUpdate
     * @request PUT:/api/Cluster/{id}
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    clusterUpdate: (id: string, data: Cluster, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Cluster/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cluster
     * @name ClusterDelete
     * @request DELETE:/api/Cluster/{id}
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    clusterDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Cluster/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name DataSystemTimesList
     * @request GET:/api/Data/systemTimes
     * @secure
     * @response `200` `void` OK
     * @response `401` `void` Unauthorized
     */
    dataSystemTimesList: (params: RequestParams = {}) =>
      this.request<void, void>({
        path: `/api/Data/systemTimes`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name DataDetail
     * @request GET:/api/Data/{clusterId}
     * @secure
     * @response `200` `(GetPersistedVectorMeasurementResponse)[]` OK
     * @response `401` `void` Unauthorized
     */
    dataDetail: (
      clusterId: string,
      query?: {
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
        /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul> */
        type?: MeterTypeInternal;
        /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
        range?: MeasurementDataRangeInternal;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetPersistedVectorMeasurementResponse[], void>({
        path: `/api/Data/${clusterId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name DataSingleDetail
     * @request GET:/api/Data/single/{clusterId}/{installationId}/{meterId}
     * @secure
     * @response `200` `AggregatedSingleVectorMeasurementsClusterIntegrationResponse` OK
     * @response `401` `void` Unauthorized
     */
    dataSingleDetail: (
      clusterId: string,
      installationId: string,
      meterId: string,
      query?: {
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
        /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
        range?: MeasurementDataRangeInternal;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AggregatedSingleVectorMeasurementsClusterIntegrationResponse,
        void
      >({
        path: `/api/Data/single/${clusterId}/${installationId}/${meterId}`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Data
     * @name DataAggregatedList
     * @request GET:/api/Data/{clusterId}/aggregated
     * @secure
     * @response `200` `AggregatedVectorMeasurementsClusterIntegrationResponse` OK
     * @response `401` `void` Unauthorized
     */
    dataAggregatedList: (
      clusterId: string,
      query?: {
        /** @format date-time */
        from?: string;
        /** @format date-time */
        to?: string;
        /** <p>Members:</p><ul><li>0: Unknown</li><li>1: Internal</li><li>2: Standalone</li><li>3: BudgetPlug</li></ul> */
        type?: MeterTypeInternal;
        /** <p>Members:</p><ul><li>0: Unknown</li><li>1: None</li><li>2: InHours</li><li>3: InDays</li><li>4: InMonths</li><li>5: InYears</li></ul> */
        range?: MeasurementDataRangeInternal;
        installationIds?: string[];
      },
      params: RequestParams = {},
    ) =>
      this.request<
        AggregatedVectorMeasurementsClusterIntegrationResponse,
        void
      >({
        path: `/api/Data/${clusterId}/aggregated`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
